import FormField from "./FormField";
import dayjs from "dayjs";

export default class DateField extends FormField {
    constructor(isOptional = false, initialValue = undefined, feature = undefined) {
        super(isOptional, initialValue || dayjs(), feature);
    }

    defaultValue() {
        return dayjs();
    }
} 